module.exports = __webpack_public_path__ + "static/media/folder.8eb98f96.svg";